import React from 'react';
export const Button = React.forwardRef(({ children, ...props }, ref) => (<button {...props} ref={ref}>{children}</button>));
